import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import {
  Notification
} from 'element-ui';
import {
  VueAxios
} from './axios'

// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 60000 // 请求超时时间
})

// request interceptor
service.interceptors.request.use(config => {
  const token = store.getters.token;
  if (token) {
    config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  return config
})

// response interceptor
service.interceptors.response.use((response) => {
  return response.data
}, err => {
  if (err.response) {
    const data = err.response.data
    const token = store.getters.token;
    if (err.response.status === 400) {
      console.warn('接口400')
      return
    }
    if (err.response.status === 403) {
      Notification.error({
        title: '请求频繁',
        message: data.error
      })
      return
    }
    if (err.response.status === 422) {
      Notification.error({
        title: '错误',
        message: data.error
      })
      return
    }
    if (err.response.status === 401) {
      Notification.error({
        title: '登录状态异常',
        message: '登录验证失败,清重新登录'
      })
      if (token) {
        store.commit('SETTOKEN', null)
        setTimeout(() => {
          window.location.reload()
        }, 1500)
      }
      return;
    }
    Notification.error({
      title: '错误',
      message: '接口调用失败'
    })
  }
  return Promise.reject(err)
})

const installer = {
  vm: {},
  install(Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}